import { render, staticRenderFns } from "./PageViewsTable.vue?vue&type=template&id=f1763aa6&scoped=true&"
import script from "./PageViewsTable.vue?vue&type=script&lang=js&"
export * from "./PageViewsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1763aa6",
  null
  
)

export default component.exports